import { render, staticRenderFns } from "./DettaglioCategoria.vue?vue&type=template&id=87bcb806&"
import script from "./DettaglioCategoria.vue?vue&type=script&lang=js&"
export * from "./DettaglioCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports